import { DataFrame, PrometheusQuerySpec } from '@/core';
import { ResponseHandler, ResultType } from '../types';
import { NATIVE_HISTOGRAM_ERROR_MESSAGE, transformQueryResultToTabularDataFrame } from './utils';

export const tableResponseHandler: ResponseHandler = {
  [ResultType.NativeHistogram]: () => {
    throw new Error(NATIVE_HISTOGRAM_ERROR_MESSAGE);
  },
  [ResultType.TimeSeriesHistogram]: (result, metadata, notices, context) => {
    // Add notice recommending heatmap or histogram_quantile for histogram buckets
    notices.push({
      type: 'warning',
      message: 'Queries resulted in histograms.',
      description: 'Consider calculating aggregated quantile by adding histogram_quantile() or using a heatmap.',
    });
    const dataFrame = transformQueryResultToTabularDataFrame({
      result,
      spec: context.spec as PrometheusQuerySpec,
      compareResult: context.compareResult,
      compareDurationInMs: context.compareDurationInMs,
      alias: context.alias,
    });

    return {
      type: 'Table',
      data: {
        metadata: {
          ...metadata,
          notices,
        },
        data: dataFrame,
      },
    };
  },
  [ResultType.TimeSeries]: (result, metadata, _notices, context) => {
    const dataFrame: DataFrame = transformQueryResultToTabularDataFrame({
      result,
      spec: context.spec as PrometheusQuerySpec,
      compareResult: context.compareResult,
      compareDurationInMs: context.compareDurationInMs,
      alias: context.alias,
    });
    return {
      type: 'Table',
      data: {
        metadata,
        data: dataFrame,
      },
    };
  },
};
